import {
  AdminPlayerRestriction,
  FraudControlConfig,
  FraudControlConfigResponse,
  FraudControlsApi,
  FraudRestrictionsAdminPage,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getConfig = async (): Promise<FraudControlConfigResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(FraudControlsApi)
  return await api.getFraudControlConfig({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  })
}

const updateConfig = async (config: FraudControlConfig): Promise<FraudControlConfig> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(FraudControlsApi)
  return await api.updateFraudControlConfig({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    fraudControlConfig: config,
  })
}

const getRestrictions = async (
  resultStart: number,
  resultEnd: number,
): Promise<FraudRestrictionsAdminPage> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(FraudControlsApi)
  return await api.getCurrentFraudRestrictions({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    resultStart,
    resultEnd,
  })
}

const blockPlayer = async (
  playerLookupId: string,
  note: string,
): Promise<AdminPlayerRestriction> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(FraudControlsApi)
  return await api.blockPlayer({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    playerLookupId,
    fraudBlockPlayerRequest: { note },
  })
}

const overrideRestriction = async (restrictionId: string, note: string): Promise<void> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(FraudControlsApi)
  await api.overrideRestriction({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    restrictionId,
    fraudOverrideRestrictionRequest: { note },
  })
}

export const FraudServiceAPI = {
  getConfig,
  updateConfig,
  getRestrictions,
  blockPlayer,
  overrideRestriction,
}
